export default __webpack_public_path__ + "static/1-2b9ac21fedc6f3414e5ab015c97d981e.jpg";